<template>
  <div class="setting-change-pwd module-item-style">
    <el-form :model="accountForm" :rules="accountFormRules" ref="accountForm" label-width="100px" class="setting-change-pwd-form">
      <el-form-item
          label="原密码"
          prop="oldPwd" >
        <el-input type="password" v-model="accountForm.oldPassword" autocomplete="off" placeholder="请输入原密码"></el-input>
      </el-form-item>
      <el-form-item
          label="新密码"
          prop="newPwd">
        <el-input type="password" v-model="accountForm.newPassword" minlength="6" maxlength="32" autocomplete="off"  placeholder="请输入6～32位字母或数字"></el-input>
      </el-form-item>
      <el-form-item
          label="确认新密码"
          prop="checkPwd">
        <el-input type="password" v-model="accountForm.confirmPass" minlength="6" maxlength="32" autocomplete="off"  placeholder="请确认新密码"></el-input>
      </el-form-item>
      <el-form-item>
        <span class="wl-btn" @click="submitForm('accountForm')">保存 </span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'setting-change-pwd',
    data() {
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else if (value.trim().length < 6 ) {
          callback(new Error('请输入至少6位新密码'));
        }else if (value.trim().length > 32 ) {
          callback(new Error('最多输入32位新密码'));
        } else {
          callback();
        }
      };
      let validateCheckPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.accountForm.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        accountForm:{
          oldPassword: '',
          newPassword:'',
          confirmPass:''
        },
        accountFormRules:{
          oldPassword: [
            { required: true, message: '请输入原密码', trigger: 'blur' }
          ],
          newPassword: [
            { required: true, validator: validatePass, trigger: 'blur' }
          ],
          confirmPass: [
            { required: true, validator: validateCheckPass, trigger: 'blur' }
          ],
        }
      }
    },
    mounted() {

    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let postData = this.accountForm
           this.$http.changePasswordAPI(postData).then( res => {
             if(res.status == 1){
               this.$message({
                 message: res.msg,
                 type: 'success',
               })
               this.$store.dispatch('user/resetToken')
               this.$router.push({
                 path:'/'
               })
             }else {
               this.$message({
                 message: res.msg,
                 type: 'error',
               })
             }
           })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
  }
</script>

<style lang="scss">
.setting-change-pwd{
  .setting-change-pwd-form{
    width: 300px;
  }
}
</style>
